@if (gated()) {
  <bit-callout
    type="subtle"
    icon="bwi-lock-encrypted"
    [title]="null"
    [accessibleName]="bannerName"
    data-testid="pam-gated-collection-banner"
  >
    {{ requiresRequestLabel }}
  </bit-callout>
}
